// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1n_AZ","title":"FrontImage_title__1Tv2N"};